<template>
  <quoteBasic
    :title="'Refer Partner Leads'"
    :propsMode="'new'"
    :quoteType="'leads'"
    :leadSource="'RRL'"
  ></quoteBasic>
</template>
<script>
import quoteBasic from '../../../components/quote/quoteBasic.vue'

export default {
  name: 'LeadsNew',
  components: {
    quoteBasic
  }
}
</script>
